import WaveSurferJs from 'wavesurfer.js';
import { useEffect } from 'react';
import { AUDIO_TRACK_CONTAINER_ID } from 'app/components/AudioPlayer/AudioPlayerTrack/constants';
import Hover from 'wavesurfer.js/dist/plugins/hover';
import { Theme, useTheme } from '@chakra-ui/react';
import {
  colorWithOpacityOverSpecificColorRGB,
  hexToRgb,
} from 'app/utils/utils';
import { getColor, mode } from '@chakra-ui/theme-tools';

export const WAVE_HEIGHT = 40;

export type WaveSurferInstance = WaveSurferJs;

const useMountPlayer = () => {
  const theme = useTheme<Theme>();
  const waveColor = getColor(theme, mode('M.40', 'M.40')(theme));
  const progressColor = getColor(theme, mode('P.80', 'P.80')(theme));
  const white = getColor(theme, mode('white', 'white')(theme));

  useEffect(() => {
    const container = document.getElementById(
      AUDIO_TRACK_CONTAINER_ID
    ) as HTMLElement;

    const splitChannels = [
      {
        normalize: true,
        waveColor,
        progressColor,
      },
      {
        overlay: true,
        waveColor: colorWithOpacityOverSpecificColorRGB(
          hexToRgb(white)!,
          hexToRgb(waveColor)!,
          0.18
        ),
        progressColor: colorWithOpacityOverSpecificColorRGB(
          hexToRgb(white)!,
          hexToRgb(progressColor)!,
          0.18
        ),
        barHeight: 4,
      },
    ];

    if (!window.player) {
      window.player = WaveSurferJs.create({
        container,
        height: WAVE_HEIGHT,
        hideScrollbar: true,
        plugins: [Hover.create()],
        barRadius: 30,
        splitChannels,
      });
    } else {
      window.player.setOptions({
        container,
        splitChannels,
      });
    }
  }, [progressColor, waveColor, white]);

  return window.player;
};

export const useWaveSurferPlayer = () => useMountPlayer();
